// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansLight_d6f553', '__IBMPlexSansLight_Fallback_d6f553'","fontWeight":300},"className":"__className_d6f553","variable":"__variable_d6f553"};